import axios from "axios";
import store from '@/state/store'
import {version} from "../../package"

const axiosConfig = {
    baseURL: process.env.VUE_APP_SERVER_URL,
    headers: {
        "Content-type": "application/json",
    }
};
const axiosClient = axios.create(axiosConfig);
axiosClient.interceptors.request.use(
    (config) => {
        const token = store.getters['auth/getToken'];
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        config.headers['AppVersion'] = `version-${version}`;

        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);

export default axiosClient;